import { render, staticRenderFns } from "./newBarChart.vue?vue&type=template&id=2298d034&scoped=true&"
import script from "./newBarChart.vue?vue&type=script&lang=js&"
export * from "./newBarChart.vue?vue&type=script&lang=js&"
import style0 from "./newBarChart.vue?vue&type=style&index=0&id=2298d034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298d034",
  null
  
)

export default component.exports